const FilterSections = {
    TYRE_INDEX_VIEW: 'tyreIndex',
    BRAND_VIEW: 'brand',
    PRICE_VIEW: 'price',
    DEALS_VIEW: 'deals',
    FEATURES_VIEW: 'features',
    USAGE_VIEW: 'usage',
    ADDITIONAL_VIEW: 'additional',
    WHEEL_BRAND_VIEW: 'wheelBrand',
    WHEEL_SIZE_VIEW: 'wheelSize',
    WHEEL_BOLT_PATTERN_VIEW: 'wheelBoltPattern',
    FITMENT_VIEW: 'fitment',
    VEHICLE_TYRES: null,
    TECHNOLOGY_VIEW: 'technology',
    TYRE_RATINGS_VIEW: 'tyreRatings',
    CUSTOMER_REVIEWS_VIEW: 'customerReviews',
    QUALITY_SEGMENT_VIEW: 'qualitySegment',
    SEASON_VIEW: 'season',
    EV_VIEW: 'ev',
};

export { FilterSections };